<template>
	<div>
		<v-list two-line="" subheader>
			<v-list-tile avatar @click="onTemplateSelect(null)">
				<v-list-tile-avatar>
					<v-icon class="grey white--text">mdi-file-hidden</v-icon>
				</v-list-tile-avatar>

				<v-list-tile-content>
					<v-list-tile-title>Custom Review</v-list-tile-title>
					<v-list-tile-sub-title>Create a custom review from the ground up</v-list-tile-sub-title>
				</v-list-tile-content>

				<v-list-tile-action>
					<v-icon color="grey lighten-1">chevron_right</v-icon>
				</v-list-tile-action>
			</v-list-tile>

			<v-list-tile v-for="template in templates" :key="template.id" avatar @click="onTemplateSelect(template)">
				<v-list-tile-avatar>
					<v-icon class="amber white--text">mdi-file-document-edit-outline</v-icon>
				</v-list-tile-avatar>

				<v-list-tile-content>
					<v-list-tile-title>{{ template.name }}</v-list-tile-title>
					<v-list-tile-sub-title>Custom Template</v-list-tile-sub-title>
				</v-list-tile-content>

				<v-list-tile-action>
					<v-icon color="grey lighten-1">chevron_right</v-icon>
				</v-list-tile-action>
			</v-list-tile>
		</v-list>
	</div>
</template>

<script>
	export default {
		props: {
			templates: {
				required: true,
				type: Array
			}
		},
		data: () => ({}),
		methods: {
			onTemplateSelect(template) {
				this.$emit('onTemplateSelect', template);
			}
		}
	};
</script>

<style></style>
